import * as z from 'zod';
import { extractionStatusSchema, ExtractionStatus, extractionErrorTypeSchema } from '../../../enums.mjs';
import { fileId } from '../../opaque.mjs';
import { WipScheduleData } from './wip-schedule-data.mjs';

var ExtractionResultPayload;
(function (ExtractionResultPayload) {
    ExtractionResultPayload.schema = z.object({
        fileId: fileId,
        status: extractionStatusSchema.extract([ExtractionStatus.Completed, ExtractionStatus.Partial]),
        processingSessionId: z.string().nullable(),
        output: WipScheduleData.schema,
    });
})(ExtractionResultPayload || (ExtractionResultPayload = {}));
var ExtractionFailurePayload;
(function (ExtractionFailurePayload) {
    ExtractionFailurePayload.schema = z.object({
        fileId: fileId,
        status: z.literal("failed"),
        errorType: extractionErrorTypeSchema,
        errorMessage: z.string(),
    });
})(ExtractionFailurePayload || (ExtractionFailurePayload = {}));
var ExtractionWebhookPayload;
(function (ExtractionWebhookPayload) {
    ExtractionWebhookPayload.schema = z.discriminatedUnion("status", [
        ExtractionResultPayload.schema,
        ExtractionFailurePayload.schema,
    ]);
})(ExtractionWebhookPayload || (ExtractionWebhookPayload = {}));

export { ExtractionFailurePayload, ExtractionResultPayload, ExtractionWebhookPayload };
